import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import warrantyIcon from "./assets/warranty-3d-icon.png";
export default function WarrantyNotSelectedTrigger(_ref) {
  var _data$items, _data$selected;
  var data = _ref.data,
    onClick = _ref.onClick,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? "bg-[#F1F6FC]" : _ref$bgColor,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? "text-[13px]" : _ref$titleSize,
    _ref$subtitleSize = _ref.subtitleSize,
    subtitleSize = _ref$subtitleSize === void 0 ? "text-sm" : _ref$subtitleSize;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  if (!(data !== null && data !== void 0 && (_data$items = data.items) !== null && _data$items !== void 0 && _data$items.length)) return null;

  // Use the icon from data.selected or fallback to the first item's icon
  var iconSrc = (_data$selected = data.selected) === null || _data$selected === void 0 ? void 0 : _data$selected.icon;
  var displayTitle = tShort("warranty/empty_title", {
    ns: "web_checkout_cash"
  });
  var displaySubtitle = tShort("warranty/empty_subtitle", {
    ns: "web_checkout_cash"
  });
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "w-full cursor-pointer focus:outline-none "
  }, /*#__PURE__*/React.createElement("div", {
    className: "gap-1 flex items-center rounded-lg border-solid border-[1px] border-[#0D0DB5] ".concat(bgColor, " px-1 py-1 hover:bg-[#e8e8f8] transition-colors")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    src: warrantyIcon,
    width: "40",
    height: "45",
    alt: "Warranty Icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end text-start flex-1 min-w-0"
  }, displayTitle && /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] ".concat(titleSize, " leading-6 break-words w-full text-start")
  }, displayTitle), displaySubtitle && /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] ".concat(subtitleSize, " leading-6 break-words w-full text-start")
  }, displaySubtitle)), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-1 rounded-md bg-primary-new p-2 items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-white text-[11px] leading-tight whitespace-nowrap"
  }, tShort("warranty/empty_cta", {
    ns: "web_checkout_cash"
  }))))));
}